/* FSM-104 / FSM-103: horizontal rails for the homepage category slider and the
   All Collections page. Behaviour follows Jay's design logic:
   - data-fz-rail="deck"   (homepage)   pages by visible cards minus one, progress bar,
                                         autoplay only after the visitor has scrolled ~3 cards
   - data-fz-rail="paged"  (collections) pages by a full view, wraps around at either end */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__fzRail) return;
    var track = root.querySelector('[data-fz-track]');
    if (!track) return;
    root.__fzRail = true;

    var mode = root.getAttribute('data-fz-rail');
    var autoMs = reduceMotion ? 0 : parseInt(root.getAttribute('data-fz-autoplay') || '0', 10);
    var prev = root.querySelector('[data-fz-prev]');
    var next = root.querySelector('[data-fz-next]');
    var bar = root.querySelector('[data-fz-bar]');
    var timer = null, paused = false, resumeT = null;

    function gap() {
      var cs = getComputedStyle(track);
      var g = parseFloat(cs.columnGap || cs.gap);
      return isNaN(g) ? 24 : g;
    }
    function cardStep() {
      var c = track.firstElementChild;
      return c ? c.getBoundingClientRect().width + gap() : track.clientWidth * 0.8;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }

    function step(dir) {
      var w = cardStep(), max = maxScroll(), per;
      if (mode === 'deck') {
        per = Math.max(1, Math.floor(track.clientWidth / w));
        track.scrollBy({ left: dir * w * Math.max(1, per - 1), behavior: 'smooth' });
        return;
      }
      per = Math.max(1, Math.round(track.clientWidth / w));
      var target = track.scrollLeft + dir * w * per;
      if (dir > 0 && track.scrollLeft >= max - 4) target = 0;
      else if (dir < 0 && track.scrollLeft <= 4) target = max;
      track.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: 'smooth' });
    }

    function measure() {
      // nothing to scroll (e.g. 3 cards on desktop): hide the controls and centre the cards
      root.classList.toggle('fz-rail--static', maxScroll() <= 4);
      if (bar) {
        var width = Math.max(track.scrollWidth, 1), view = Math.max(track.clientWidth, 1);
        var frac = Math.max(0.08, Math.min(1, view / width));
        var max = Math.max(1, width - view);
        bar.style.width = (frac * 100).toFixed(1) + '%';
        bar.style.left = ((Math.min(track.scrollLeft, max) / max) * (1 - frac) * 100).toFixed(1) + '%';
      }
      maybeAuto();
    }

    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    function maybeAuto() {
      if (!autoMs || timer || paused) return;
      var max = maxScroll();
      if (max < 40) return;
      var trigger = Math.min(cardStep() * 3 - 8, max * 0.5);
      if (track.scrollLeft < trigger - 2) return;
      timer = setInterval(function () {
        if (paused) return;
        if (track.scrollLeft >= maxScroll() - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      }, autoMs);
    }
    function pauseAuto() {
      paused = true; stopAuto(); clearTimeout(resumeT);
      resumeT = setTimeout(function () { paused = false; maybeAuto(); }, 5000);
    }

    if (prev) prev.addEventListener('click', function () { pauseAuto(); step(-1); });
    if (next) next.addEventListener('click', function () { pauseAuto(); step(1); });
    track.addEventListener('scroll', measure, { passive: true });
    if (autoMs) {
      track.addEventListener('mouseenter', function () { stopAuto(); paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; maybeAuto(); });
      track.addEventListener('focusin', function () { stopAuto(); paused = true; });
    }
    window.addEventListener('resize', measure);
    measure();
  }

  function boot() { document.querySelectorAll('[data-fz-rail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
